export class SpiceProperties {


}

//export class SpiceSSR {
//  GetSSRAvailabilityForBookingResponse: GetSSRAvailabilityForBookingResponse;
//}

export class SpiceSSR {
  SSRAvailabilityForBookingResponse: SSRAvailabilityForBookingResponse;
  "_xmlns:xsi": string;
  "_xmlns:xsd": string;
}

export class SSRAvailabilityForBookingResponse {
  ExtensionData: string;
  OtherServiceInfoList: string;
  SSRSegmentList: SSRSegmentList[];
}

export class SSRSegmentList {
  ExtensionData: string;
  LegKey: LegKey;
  AvailablePaxSSRList: AvailablePaxSSRList[];
}

//export class SSRSegment {
//  ExtensionData: string;
//  LegKey: LegKey;
//  AvailablePaxSSRList: AvailablePaxSSRList;
//}

export class AvailablePaxSSRList {
  ExtensionData: string;
  SSRCode: string;
  InventoryControlled: string;
  NonInventoryControlled: string;
  SeatDependent: string;
  NonSeatDependent: string;
  Available: string;
  PassengerNumberList: AvailablePaxSSRPassengerNumberList;
  PaxSSRPriceList: PaxSSRPriceListClass | string;
  SSRLegList: SSRLegListClass[]=[];
}

export class AvailablePaxSSR {

}

export class AvailablePaxSSRPassengerNumberList {
  short: string[] | string;
}

export class PaxSSRPriceListClass {
  PaxSSRPrice: PaxSSRPrice;
}

export class PaxSSRPrice {
  ExtensionData: string;
  PaxFee: PaxFee;
  PassengerNumberList: PaxSSRPricePassengerNumberList;
}

export class PaxSSRPricePassengerNumberList {
  short: string;
}

export class PaxFee {
  ExtensionData: string;
  State: State;
  ActionStatusCode: ActionStatusCode;
  FeeCode: string;
  FeeDetail: string;
  FeeNumber: string;
  FeeType: FeeType;
  FeeOverride: string;
  FlightReference: string;
  Note: string;
  SSRCode: string;
  SSRNumber: string;
  PaymentNumber: string;
  ServiceCharges: ServiceCharges;
  CreatedDate: Date;
  IsProtected: string;
  FeeApplicationType: FeeApplicationType;
}

export enum ActionStatusCode {
  Nn = "NN",
}

export enum FeeApplicationType {
  Journey = "Journey",
  Leg = "Leg",
  Segment = "Segment",
}

export enum FeeType {
  SSRFeee = "SSRFee",
}

export class ServiceCharges {
  BookingServiceCharge: BookingServiceChargeElement[] | BookingServiceChargeElement;
}

export class BookingServiceChargeElement {
  ExtensionData: string;
  State: State;
  ChargeType: ChargeType;
  CollectType: CollectType;
  ChargeCode: string;
  TicketCode: string;
  CurrencyCode: CurrencyCode;
  Amount: string;
  ChargeDetail: string;
  ForeignCurrencyCode: CurrencyCode;
  ForeignAmount: string;
}

export enum ChargeType {
  IncludedTax = "IncludedTax",
  ServiceCharge = "ServiceCharge",
  Tax = "Tax",
}

export enum CollectType {
  SellerChargeable = "SellerChargeable",
}

export enum CurrencyCode {
  Aed = "AED",
}

export enum State {
  New = "New",
}

export class SSRLegListClass {
  //SSRLeg: SSRLeg;
  LegKey: LegKey;
}

//export class SSRLeg {
//  ExtensionData: string;
  
//  Available: string;
//}

export class LegKey {
  ExtensionData: string;
  CarrierCode: CarrierCode;
  FlightNumber: string;
  OpSuffix: string;
  DepartureDate: Date;
  DepartureStation: string;
  ArrivalStation: string;
}

export enum ArrivalStation {
  BOM = "BOM",
}

export enum CarrierCode {
  Sg = "SG",
}
export enum DepartureStation {
  Del = "DEL",
}
/////////////////////////////////////////////////////////////////
//export class SpiceSeat {
//  SpiceSeats: SpiceSeatList;
//}

export class SpiceSeat {
  SeatAvailabilityResponse: SeatAvailabilityResponse;
  "_xmlns:xsi": string;
  "_xmlns:xsd": string;
}

export class SeatAvailabilityResponse {
  ExtensionData: string;
  EquipmentInfos: EquipmentInfos;
  SeatGroupPassengerFees: SeatGroupPassengerFees[];
  Legs: Legs[];
  PropertyTypeCodesLookup: PropertyTypeCodesLookup;
}


export class SeatGroupPassengerFees {

  SeatGroup: number;
  PassengerFee: PassengerFee;
  PassengerNumber: number;

}

export enum FeeType {
            All = 0,
            Tax = 1,
            TravelFee = 2,
            ServiceFee = 3,
            PaymentFee = 4,
            PenaltyFee = 5,
            SSRFee = 6,
            NonFlightServiceFee = 7,
            UpgradeFee = 8,
            SeatFee = 9,
            BaseFare = 10,
            SpoilageFee = 11,
            NameChangeFee = 12,
            ConvenienceFee = 13,
            BaggageFee = 14,
            FareSurcharge = 15,
            PromotionDiscount = 16,
            ServiceBundle = 17,
            ExtraBagFee = 18,
            Unmapped = -1,

                  }
export class PassengerFee {
  ActionStatusCode: string;
  FeeCode: string;
  FeeDetail: string;
 FeeNumber:number;
  FeeType: FeeType;
  FeeOverride: boolean;
  FlightReferenceField: string;
  Note: string;
  SSRCode: string;
  SSRNumber: number;
  PaymentNumber:number;
  ServiceCharges: BookingServiceCharge[];
 CreatedDate:Date;
  IsProtected: boolean;
  FeeApplicationType: FeeApplicationType;
}
export class BookingServiceCharge {

  ChargeTypeField: ChargeType;

   CollectTypeField: CollectType;

   ChargeCode: string;

   TicketCode: string;

   CurrencyCode: string;

   Amount: number;

   ChargeDetail: string;

   ForeignCurrencyCode: string;

   ForeignAmount:number;


}
export class EquipmentInfos {
  EquipmentInfo: EquipmentInfo;
}

export class EquipmentInfo {
  ExtensionData: string;
  ArrivalStation: string;
  DepartureStation: string;
  EquipmentType: string;
  EquipmentTypeSuffix: string;
  AvailableUnits: string;
  Compartments: Compartments;
  EquipmentCategory: string;
  PropertyList: string;
  MarketingCode: string;
  Name: string;
  PropertyTimestamp: Date;
}

export class Compartments {
  CompartmentInfo: CompartmentInfo;
}

export class CompartmentInfo {
  ExtensionData: string;
  CompartmentDesignator: CompartmentDesignator;
  Deck: string;
  Length: string;
  Width: string;
  AvailableUnits: string;
  Orientation: string;
  Sequence: string;
  Seats: Seats;
  PropertyList: CompartmentInfoPropertyList;
  PropertyTimestamp: Date;
}

export enum CompartmentDesignator {
  Empty = "",
  Y = "Y",
}

export class CompartmentInfoPropertyList {
  EquipmentProperty: EquipmentPropertyElement;
}

export class EquipmentPropertyElement {
  ExtensionData: string;
  TypeCode: string;
  Value: string;
}

export class Seats {
  SeatInfo: SeatInfo[];
}

export class SeatInfo {
  Amount: number;
  ExtensionData: string;
  Assignable: string;
  CabotageLevel: string;
  CarAvailableUnits: string;
  CompartmentDesignator: CompartmentDesignator;
  SeatSet: string;
  CriterionWeight: string;
  SeatSetAvailableUnits: string;
  SSRSeatMapCode: string;
  SeatAngle: string;
  SeatAvailability: SeatAvailability;
  SeatDesignator: string;
  SeatType: SeatType;
  X: string;
  Y: string;
  PropertyList: PropertyListPropertyList | string;
  SSRPermissions: string;
  TravelClassCode: CompartmentDesignator;
  PropertyTimestamp: Date;
  SeatGroup: string;
  Zone: string;
  Height: string;
  Width: string;
  Priority: string;
  Text: string;
  ODPenalty: string;
  TerminalDisplayCharacter: TerminalDisplayCharacter;
  PremiumSeatIndicator: string;
}

export class PropertyListPropertyList {
  EquipmentProperty: EquipmentPropertyElement[] | EquipmentPropertyElement;
}

export enum SeatAvailability {
  FleetBlocked = "FleetBlocked",
  Open = "Open",
  Unknown = "Unknown",
}

export enum SeatType {
  Bh = "BH",
  Ex = "EX",
  Lr = "LR",
  NS = "NS",
  Wg = "WG",
}

export enum TerminalDisplayCharacter {
  Empty = "^",
  R = "r",
  TerminalDisplayCharacter = "-",
}

export class Legs {
  //SeatAvailabilityLeg: SeatAvailabilityLeg;
  ExtensionData: string;
  ArrivalStation: string;
  DepartureStation: string;
  STA: Date;
  STD: Date;
  FlightDesignator: FlightDesignator;
  AircraftType: string;
  AircraftTypeSuffix: string;
  EquipmentIndex: string;
}

//export class SeatAvailabilityLeg {
//  ExtensionData: string;
//  ArrivalStation: string;
//  DepartureStation: string;
//  STA: Date;
//  STD: Date;
//  FlightDesignator: FlightDesignator;
//  AircraftType: string;
//  AircraftTypeSuffix: string;
//  EquipmentIndex: string;
//}

export class FlightDesignator {
  ExtensionData: string;
  CarrierCode: string;
  FlightNumber: string;
  OpSuffix: string;
}

export class PropertyTypeCodesLookup {
  ExtensionData: string;
  BooleanPropertyTypes: BooleanPropertyTypes;
  NumericPropertyTypeCodes: Codes;
  SSRCodes: Codes;
  Timestamp: Date;
}

export class BooleanPropertyTypes {
  EquipmentProperty: EquipmentPropertyElement[];
}

export class Codes {
  string: string[];
}







